// externals
import * as React from 'react';

// libraries
import { Modal, PageUI } from '@makemydeal/dr-activities-common';

// components
import RulesUI from './RulesUI';

export interface IGTPRulesModalProps {
    show: boolean;
    onClose: () => void;
    dispatchAnalytics: (type: string, description: string) => void;
}

const GTPRulesModal: React.FC<IGTPRulesModalProps> = ({ show, onClose, dispatchAnalytics }) => (
    <Modal
        show={show}
        elementToAttachModalTo=".checkout-wizard-layout__wrapper"
        elementToBlur=".checkout-wizard-layout__container"
        cls="dr_trade_subaru_rules_modal"
    >
        <PageUI
            pageClass="dr_trade_subaru_rules_page"
            pageTitle="Rules and Eligibility"
            footerProps={{
                onActionButtonClick: onClose,
                showBackButton: false,
                buttonText: 'Close',
                disableActionButton: false
            }}
            dispatchAnalytics={dispatchAnalytics}
        >
            <RulesUI />
        </PageUI>
    </Modal>
);

export default GTPRulesModal;
